const RejectedIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_370_1905)">
        <path
          d="M7.99995 0.450012C3.82495 0.450012 0.449951 3.82501 0.449951 8.00001C0.449951 12.175 3.82495 15.575 7.99995 15.575C12.175 15.575 15.575 12.175 15.575 8.00001C15.575 3.82501 12.175 0.450012 7.99995 0.450012ZM7.99995 14.45C4.44995 14.45 1.57495 11.55 1.57495 8.00001C1.57495 4.45001 4.44995 1.57501 7.99995 1.57501C11.55 1.57501 14.45 4.47501 14.45 8.02501C14.45 11.55 11.55 14.45 7.99995 14.45Z"
          fill="#BA0C2F"
        />
        <path
          d="M10.2999 5.67504C10.0749 5.45004 9.72485 5.45004 9.49985 5.67504L7.99985 7.20004L6.47485 5.67504C6.24985 5.45004 5.89985 5.45004 5.67485 5.67504C5.44985 5.90004 5.44985 6.25004 5.67485 6.47504L7.19985 8.00004L5.67485 9.52504C5.44985 9.75004 5.44985 10.1 5.67485 10.325C5.77485 10.425 5.92485 10.5 6.07485 10.5C6.22485 10.5 6.37485 10.45 6.47485 10.325L7.99985 8.80004L9.52485 10.325C9.62485 10.425 9.77485 10.5 9.92485 10.5C10.0749 10.5 10.2249 10.45 10.3249 10.325C10.5499 10.1 10.5499 9.75004 10.3249 9.52504L8.79985 8.00004L10.3249 6.47504C10.5249 6.25004 10.5249 5.90004 10.2999 5.67504Z"
          fill="#BA0C2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_370_1905">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RejectedIcon;
